import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Button.css';

const Button = ({
  className = '',
  theme = 'primary',
  onClick = () => {},
  children,
  ...otherProps
}) => {

  const classes = classNames(
    'ng-ui-widgets',
    'ng-ui-button',
    `theme-${theme}`,
    className,
  );

  return (
    <button
      className={classes}
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </button>
  );
};



Button.propTypes = {
  onClick: PropTypes.func,
  theme: PropTypes.oneOf([
    'primary',
    'secondary',
    'custom',
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
};

export default Button;